module.exports = __webpack_public_path__ + "static/media/become_a_host_mobile.3d191c39.webp";